var map = {
	"./0409151406.jpeg": 5169,
	"./IMG_0525.jpeg": 5374,
	"./IMG_2277.jpeg": 3269,
	"./blueChrist.acd0e0a4.jpg": 2621,
	"./christ.22f95739.JPG": 5632,
	"./firstChur.36978bae.jpg": 8731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4478;